<script>
import transitionFade from '../transition/fade';
import shadowBox from '../shadow';
export default {
    props: {
        status: {
            type: Boolean,
            default: false
        },
        zIndex: {
            type: Number,
            default: 100000
        },
        text: {
          type: String,
          default: ''
        }
    },
    components: {
        transitionFade,
        shadowBox
    }
}
</script>

<template>
    <shadow-box 
        :status="status"
    >
        <transition-fade>
            <div class="loading-wrap">
              <div 
                  :style="{'z-index': zIndex}"
                  class="loading-anim">
                  <div class="shape shape1"></div>
                  <div class="shape shape2"></div>
                  <div class="shape shape3"></div>
                  <div class="shape shape4"></div>
              </div>
              <div class="loading-text">{{text}}</div>
            </div>
        </transition-fade>
    </shadow-box>
</template>

<style lang="stylus" scoped>
.loading-wrap
    position absolute
    top 50%
    left 50%
    -webkit-transform translate(-50%, -50%)
    transform translate(-50%, -50%)
    text-align center
.loading-anim
    width 30px
    height 30px
    margin 0 auto 0.64rem
    -webkit-animation rotation 1s infinite
    animation rotation 1s infinite
.loading-text
    color #fff
    font-size 0.85rem
.shape
  position absolute
  width 10px
  height 10px
  border-radius 1px
  background-color #fff
.shape1
  border-top-left-radius 10px
  left 0
  -webkit-animation animationShape1 0.5s ease 0s infinite alternate
  animation animationShape1 0.5s ease 0s infinite alternate
.shape2
  border-top-right-radius 10px
  right 0
  -webkit-animation animationShape2 0.5s ease 0s infinite alternate
  animation animationShape2 0.5s ease 0s infinite alternate
.shape3
  border-bottom-left-radius 10px
  bottom 0
  -webkit-animation animationShape3 0.5s ease 0s infinite alternate
  animation animationShape3 0.5s ease 0s infinite alternate
.shape4
  border-bottom-right-radius 10px
  bottom 0
  right 0
  -webkit-animation animationShape4 0.5s ease 0s infinite alternate
  animation animationShape4 0.5s ease 0s infinite alternate

@-webkit-keyframes rotation
  from
    -webkit-transform rotate(0deg)
    transform rotate(0deg)
  to
    -webkit-transform rotate(360deg)
    transform rotate(360deg)

@keyframes rotation
  from
    -webkit-transform rotate(0deg)
    transform rotate(0deg)
  to
    -webkit-transform rotate(360deg)
    transform rotate(360deg)

@-webkit-keyframes animationShape1
  from
    -webkit-transform translate(0, 0)
    transform translate(0, 0)
  to
    -webkit-transform translate(5px, 5px)
    transform translate(5px, 5px)

@keyframes animationShape1
  from
    -webkit-transform translate(0, 0)
    transform translate(0, 0)
  to
    -webkit-transform translate(5px, 5px)
    transform translate(5px, 5px)
@-webkit-keyframes animationShape2
  from
    -webkit-transform translate(0, 0)
    transform translate(0, 0)
  to
    -webkit-transform translate(-5px, 5px)
    transform translate(-5px, 5px)

@keyframes animationShape2
  from
    -webkit-transform translate(0, 0)
    transform translate(0, 0)
  to
    -webkit-transform translate(-5px, 5px)
    transform translate(-5px, 5px)

@-webkit-keyframes animationShape3
  from
    -webkit-transform translate(0, 0)
    transform translate(0, 0)
  to
    -webkit-transform translate(5px, -5px)
    transform translate(5px, -5px)

@keyframes animationShape3
  from
    -webkit-transform translate(0, 0)
    transform translate(0, 0)
  to
    -webkit-transform translate(5px, -5px)
    transform translate(5px, -5px)

@-webkit-keyframes animationShape4
  from
    -webkit-transform translate(0, 0)
    transform translate(0, 0)
  to
    -webkit-transform translate(-5px, -5px)
    transform translate(-5px, -5px)

@keyframes animationShape4
  from
    -webkit-transform translate(0, 0)
    transform translate(0, 0)
  to
    -webkit-transform translate(-5px, -5px)
    transform translate(-5px, -5px)

</style>